module.exports = __webpack_public_path__ + "media/tgs-logo-animation.c29f8206.mp4";